// Appends Unsplash sizing/format params so images download smaller & faster.
export const optimizeImg = (url, width = 800) => {
  if (!url) return url;
  const sep = url.includes("?") ? "&" : "?";
  return `${url}${sep}w=${width}&auto=format&fit=crop`;
};
